module.exports = __webpack_public_path__ + "static/img/ghjvendormain.35fe382.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color/color-3/ghjvendormain.png
// module id = SKUz
// module chunks = 0